import { render, staticRenderFns } from "./TransferStoreForm.vue?vue&type=template&id=772f770c&scoped=true&"
import script from "./TransferStoreForm.vue?vue&type=script&lang=js&"
export * from "./TransferStoreForm.vue?vue&type=script&lang=js&"
import style0 from "./TransferStoreForm.vue?vue&type=style&index=0&id=772f770c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772f770c",
  null
  
)

export default component.exports